import styles from './CheckBg.module.scss'

const CheckBg = ({ children }) => <div className={styles.check}>{children}</div>

export default CheckBg
